module.exports = __webpack_public_path__ + "img/footer_bg.24952d8.24952d88.png";